import { render, staticRenderFns } from "./add.vue?vue&type=template&id=40169b2c"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40169b2c')) {
      api.createRecord('40169b2c', component.options)
    } else {
      api.reload('40169b2c', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=40169b2c", function () {
      api.rerender('40169b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/distribution/plan/add.vue"
export default component.exports